<template>
  <div class="broadcast-view">
    <div class="flex flex-col w-full">
      <header
        class="bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800"
      >
        <div
          class="w-full py-2 px-4 justify-between flex-row flex justify-center"
        >
          <div class="flex flex-col">
            <div class="flex flex-row items-center">
              <h1
                class="text-lg text-slate-900 dark:text-slate-100 whitespace-nowrap mx-2"
              >
                {{ $t('BROADCAST.BROADCAST_DETAIL') }}
              </h1>
            </div>
            <div class="flex flex-row items-center mx-2">
              <div class="text-xs text-slate-900 dark:text-slate-100 mr-2">
                {{ $t('BROADCAST.TABLE.INBOX') }} :
              </div>
              <fluent-icon icon="whatsapp" size="15" />
              <div class="text-xs text-slate-900 dark:text-slate-100 ml-1">
                {{ getInboxesName }}
              </div>
            </div>
          </div>
          <div class="flex gap-2">
            <woot-button
              class="clear my-2"
              color-scheme="success"
              icon="arrow-download"
              :is-loading="isExporting"
              @click="exportExcel"
            >
              {{ $t('BROADCAST.EXPORT_EXCEL') }}
            </woot-button>
            <woot-button class="clear my-2" type="submit" @click="goBack">
              {{ $t('COMPLAINT.BACK_LABEL') }}
            </woot-button>
          </div>
        </div>
      </header>
      <!-- TABS -->
      <div
        class="flex flex-col h-full overflow-auto bg-white dark:bg-slate-900"
      >
        <woot-tabs
          id="broadcast-tabs"
          class="bg-white dark:bg-slate-900"
          :index="selectedTabIndex"
          :border="false"
          @change="onTabChange"
        >
          <woot-tabs-item
            class="tabs-items"
            v-for="tab in tabs"
            :key="tab.key"
            :name="tab.name"
            :count="tab.count"
            :show-badge="tab.count !== undefined"
          />
        </woot-tabs>
        <div v-if="selectedTabIndex === 0">
          <broadcast-stats
            :totalCount="pending_meta.totalCount"
            :pendingCount="pending_meta.pendingCount"
            :approvedCount="approvedCount"
            :deliveryStats="pending_meta.deliveryStats"
          ></broadcast-stats>
          <div class="flex-grow border-t border-gray-300 my-7 mx-4"></div>
          <div class="gap-2 flex flex-row mt-2 px-4">
            <div class="text-nowrap flex flex-col w-[70%] mr-4">
              <label class="mr-3 mb-1">{{ $t('BROADCAST.NAME_LABEL') }}</label>
              <span class="text mb-0 bg-gray-100 dark:bg-slate-800 p-2 w-full">
                {{ templateNames }}
              </span>
              <label class="mr-3 mt-4 mb-1">{{
                $t('BROADCAST.LANGUAGE_LABEL')
              }}</label>
              <span class="text mb-0 bg-gray-100 dark:bg-slate-800 p-2 w-full">
                {{ templateLanguage }}
              </span>
              <label class="mr-3 mt-4 mb-1">{{
                $t('BROADCAST.CATEGORY_LABEL')
              }}</label>
              <span class="text mb-0 bg-gray-100 dark:bg-slate-800 p-2 w-full">
                {{ templateCategory }}
              </span>
            </div>
            <message
              :headerImage="headerImage"
              :contentHeader="contentHeader"
              :contentMessages="contentMessages"
              :buttonMessages="buttonMessages"
              :isButtonMessages="isButtonMessages"
            ></message>
          </div>
          <div class="mt-10"></div>
        </div>
        <!-- Pending Tab -->
        <div v-else-if="selectedTabIndex === 1">
          <section
            class="broadcast-page bg-white dark:bg-slate-900 overflow-auto"
          >
            <div class="chat-box">
              <div
                v-if="broadcast_list.length === 0"
                class="text-center text-gray-500 py-6"
              >
                {{ $t('BROADCAST.NO_DATA_PENDING') }}
              </div>
              <div v-else>
                <div
                  v-if="uiFlags.isFetchingRecords || uiFlags.isUpdating"
                  class="flex justify-center items-center text-center text-slate-700 dark:text-slate-200 py-4"
                >
                  <spinner />{{ $t('BROADCAST.LOADING_DATA') }}
                </div>
                <div v-else>
                  <div class="my-3 mx-4 flex flex-row">
                    <!-- <div v-if="selectedRowKeys.length > 0">
                      <woot-button
                        class="clear"
                        color-scheme="alert"
                        icon="chat"
                        size="small"
                        data-testid="send-broadcast"
                        @click="openDenyModal"
                      >
                        Tolak Broadcast
                      </woot-button>
                    </div>

                    <div v-else>
                      <woot-button
                        class="flex clear justify-end"
                        color-scheme="alert"
                        icon="delete"
                        size="small"
                        data-testid="deny-broadcast"
                        @click="openDenyAllModal"
                      >
                        Tolak Semua
                      </woot-button>
                    </div> -->
                    <woot-button
                      class="clear"
                      :color-scheme="
                        selectedRowKeys.length ? 'alert' : 'success'
                      "
                      :icon="selectedRowKeys.length ? 'delete' : 'checkmark'"
                      size="small"
                      data-testid="delete-checkbox"
                      @click="toggleSelectAll"
                    >
                      {{
                        selectedRowKeys.length
                          ? $t('BROADCAST.TABLE.UNSELECT_ALL')
                          : $t('BROADCAST.TABLE.SELECT_ALL')
                      }}
                    </woot-button>
                    <woot-button
                      v-if="selectedRowKeys.length > 0"
                      class="clear"
                      color-scheme="success"
                      icon="chat"
                      size="small"
                      data-testid="send-broadcast"
                      @click="openDispatchModal"
                    >
                      {{ $t('BROADCAST.APPROVE_AND_SEND') }}
                    </woot-button>
                    <woot-button
                      class="flex clear justify-end"
                      color-scheme="warning"
                      icon="chat"
                      size="small"
                      data-testid="send-broadcast"
                      @click="openDispatchAllModal"
                    >
                      {{ $t('BROADCAST.APPROVE_AND_SEND_ALL') }}
                    </woot-button>
                  </div>
                  <broadcast-pending
                    :data="broadcast_list"
                    :meta="pending_meta"
                    :selectedRowKeys="selectedRowKeys"
                    @updateRows="handleSelectedRows"
                  ></broadcast-pending>
                </div>
              </div>
            </div>
          </section>
          <broadcast-footer
            :first-index="pendingFirstIndex"
            :last-index="pendingLastIndex"
            :total-items="pending_meta.allCount"
            :current-page="pending_meta.currentPage"
            :per-page="pending_meta.perPage"
            :has-prev-page="pendingHasPrevPage"
            :has-next-page="pendingHasNextPage"
            :items-per-page-options="[10, 25, 50, 100]"
            @update:perPage="pending_meta.perPage = $event"
            @per-page-change="onPendingPerPageChange"
            @first-page="onPendingFirstPage"
            @prev-page="onPendingPrevPage"
            @next-page="onPendingNextPage"
            @last-page="onPendingLastPage"
          >
          </broadcast-footer>
          <!-- <woot-modal
            :show.sync="showDenyAllModal"
            :on-close="closeDenyAllModal"
          >
            <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
              <woot-modal-header :header-title="'Konfirmasi'" />
              <div class="mt-2 px-8">
                <p>
                  Yakin ingin menolak pengiriman pesan broadcast ini?
                  {{ pending_meta.pendingCount }}
                </p>
                <div class="flex justify-end mt-4">
                  <div
                    class="flex flex-row justify-end items-center gap-2 px-0 w-full"
                  >
                    <woot-button
                      @click="denyAllBroadcast"
                      class="button clear"
                      :disabled="uiFlags.isUpdating"
                    >
                      <template v-if="uiFlags.isUpdating">
                        <spinner />
                      </template>
                      <template v-else>
                        {{ $t('BROADCAST.MODAL.CONFIRM_BUTTON') }}</template
                      >
                    </woot-button>
                    <woot-button
                      @click="closeDenyAllModal"
                      class="button clear"
                    >
                      {{ $t('BROADCAST.MODAL.CANCEL_BUTTON') }}
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </woot-modal>
          <woot-modal :show.sync="showDenyModal" :on-close="showDenyModal">
            <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
              <woot-modal-header
                :header-title="$t('BROADCAST.MODAL.HEADER_LABEL')"
              />
              <div class="mt-2 px-8">
                <p>
                 Ehey {{ selectedRowKeys.length }}
                </p>
                <div class="flex justify-end mt-4">
                  <div
                    class="flex flex-row justify-end items-center gap-2 px-0 w-full"
                  >
                    <woot-button
                      @click="denyBroadcast"
                      class="button clear"
                      :disabled="uiFlags.isUpdating"
                    >
                      <template v-if="uiFlags.isUpdating">
                        <spinner />
                      </template>
                      <template v-else>
                        {{ $t('BROADCAST.MODAL.CONFIRM_BUTTON') }}</template
                      >
                    </woot-button>
                    <woot-button @click="closeDenyModal" class="button clear">
                      {{ $t('BROADCAST.MODAL.CANCEL_BUTTON') }}
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </woot-modal> -->
          <woot-modal :show.sync="showSendModal" :on-close="closeSendModal">
            <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
              <woot-modal-header
                :header-title="$t('BROADCAST.MODAL.HEADER_LABEL')"
              />
              <div class="mt-2 px-8">
                <p>
                  {{
                    $t('BROADCAST.MODAL.CONFIRM_APPROVE', {
                      count: selectedRowKeys.length,
                    })
                  }}
                </p>
                <div class="flex justify-end mt-4">
                  <div
                    class="flex flex-row justify-end items-center gap-2 px-0 w-full"
                  >
                    <woot-button
                      @click="dispatchBroadcast"
                      class="button clear"
                      :disabled="uiFlags.isUpdating"
                    >
                      <template v-if="uiFlags.isUpdating">
                        <spinner />
                      </template>
                      <template v-else>
                        {{ $t('BROADCAST.MODAL.CONFIRM_BUTTON') }}</template
                      >
                    </woot-button>
                    <woot-button @click="closeSendModal" class="button clear">
                      {{ $t('BROADCAST.MODAL.CANCEL_BUTTON') }}
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </woot-modal>
          <woot-modal
            :show.sync="showSendAllModal"
            :on-close="closeSendAllModal"
          >
            <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
              <woot-modal-header
                :header-title="$t('BROADCAST.MODAL.HEADER_LABEL')"
              />
              <div class="mt-2 px-8">
                <p>
                  {{
                    $t('BROADCAST.MODAL.CONFIRM_APPROVE_ALL', {
                      count: pending_meta.pendingCount,
                    })
                  }}
                </p>
                <div class="flex justify-end mt-4">
                  <div
                    class="flex flex-row justify-end items-center gap-2 px-0 w-full"
                  >
                    <woot-button
                      @click="dispatchAllBroadcast"
                      class="button clear"
                      :disabled="uiFlags.isUpdating"
                    >
                      <template v-if="uiFlags.isUpdating">
                        <spinner />
                      </template>
                      <template v-else>
                        {{ $t('BROADCAST.MODAL.CONFIRM_BUTTON') }}</template
                      >
                    </woot-button>
                    <woot-button
                      @click="closeSendAllModal"
                      class="button clear"
                    >
                      {{ $t('BROADCAST.MODAL.CANCEL_BUTTON') }}
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </woot-modal>
        </div>
        <!-- Approved Tab -->
        <div v-else-if="selectedTabIndex === 2">
          <section
            class="broadcast-page bg-white dark:bg-slate-900 overflow-auto"
          >
            <div class="chat-box">
              <div class="flex justify-start ml-4 mt-2">
                <div class="text-nowrap w-[20%]">
                  <multiselect
                    v-model="selectedStatus"
                    :options="statusOptions"
                    track-by="key"
                    label="label"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :placeholder="$t('BROADCAST.CHOOSE_STATUS')"
                    @select="onSelectedStatus"
                    @remove="onRemoveStatus"
                  />
                </div>
              </div>
              <div
                v-if="approvedData.length === 0"
                class="text-center text-gray-500 py-6"
              >
                {{ $t('BROADCAST.NO_DATA_APPROVED') }}
              </div>
              <div v-else>
                <div
                  v-if="uiFlags.isFetchingApproved"
                  class="flex justify-center items-center text-center text-slate-700 dark:text-slate-200 py-4"
                >
                  <spinner />{{ $t('BROADCAST.LOADING_DATA') }}
                </div>
                <div v-else>
                  <broadcast-approved
                    :data="approvedData"
                    :meta="meta"
                  ></broadcast-approved>
                </div>
              </div>
            </div>
          </section>
          <broadcast-footer
            :first-index="firstIndex"
            :last-index="lastIndex"
            :total-items="meta.allCount"
            :current-page="meta.currentPage"
            :per-page="meta.perPage"
            :has-prev-page="hasPrevPage"
            :has-next-page="hasNextPage"
            :items-per-page-options="[10, 25, 50, 100]"
            @update:perPage="meta.perPage = $event"
            @per-page-change="onPerPageChange"
            @first-page="onFirstPage"
            @prev-page="onPrevPage"
            @next-page="onNextPage"
            @last-page="onLastPage"
          >
          </broadcast-footer>
        </div>
        <!-- <div v-else-if="selectedTabIndex === 3">
          <section
            class="broadcast-page bg-white dark:bg-slate-900 overflow-auto"
          >
            <div class="chat-box">
              <div
                v-if="broadcast_list.length === 0"
                class="text-center text-gray-500 py-6"
              >
                {{ $t('BROADCAST.NO_DATA_PENDING') }}
              </div>
              <div v-else>
                <div
                  v-if="uiFlags.isFetchingRecords || uiFlags.isUpdating"
                  class="flex justify-center items-center text-center text-slate-700 dark:text-slate-200 py-4"
                >
                  <spinner />{{ $t('BROADCAST.LOADING_DATA') }}
                </div>
                <div v-else>
                  <div class="my-3 mx-4 flex flex-row">
                    <woot-button
                      class="clear"
                      :color-scheme="
                        selectedRowKeys.length ? 'alert' : 'success'
                      "
                      :icon="selectedRowKeys.length ? 'delete' : 'checkmark'"
                      size="small"
                      data-testid="delete-checkbox"
                      @click="toggleSelectAll"
                    >
                      {{
                        selectedRowKeys.length
                          ? $t('BROADCAST.TABLE.UNSELECT_ALL')
                          : $t('BROADCAST.TABLE.SELECT_ALL')
                      }}
                    </woot-button>
                    <woot-button
                      v-if="selectedRowKeys.length > 0"
                      class="clear"
                      color-scheme="success"
                      icon="chat"
                      size="small"
                      data-testid="send-broadcast"
                      @click="openDispatchModal"
                    >
                      {{ $t('BROADCAST.APPROVE_AND_SEND') }}
                    </woot-button>
                    <woot-button
                      class="flex clear justify-end"
                      color-scheme="warning"
                      icon="chat"
                      size="small"
                      data-testid="send-broadcast"
                      @click="openDispatchAllModal"
                    >
                      {{ $t('BROADCAST.APPROVE_AND_SEND_ALL') }}
                    </woot-button>
                  </div>
                  <broadcast-pending
                    :data="broadcast_list"
                    :meta="pending_meta"
                    :selectedRowKeys="selectedRowKeys"
                    @updateRows="handleSelectedRows"
                  ></broadcast-pending>
                </div>
              </div>
            </div>
          </section>
          <broadcast-footer
            :first-index="pendingFirstIndex"
            :last-index="pendingLastIndex"
            :total-items="pending_meta.allCount"
            :current-page="pending_meta.currentPage"
            :per-page="pending_meta.perPage"
            :has-prev-page="pendingHasPrevPage"
            :has-next-page="pendingHasNextPage"
            :items-per-page-options="[10, 25, 50, 100]"
            @update:perPage="pending_meta.perPage = $event"
            @per-page-change="onPendingPerPageChange"
            @first-page="onPendingFirstPage"
            @prev-page="onPendingPrevPage"
            @next-page="onPendingNextPage"
            @last-page="onPendingLastPage"
          >
          </broadcast-footer>
          <woot-modal :show.sync="showSendModal" :on-close="closeSendModal">
            <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
              <woot-modal-header
                :header-title="$t('BROADCAST.MODAL.HEADER_LABEL')"
              />
              <div class="mt-2 px-8">
                <p>
                  {{
                    $t('BROADCAST.MODAL.CONFIRM_APPROVE', {
                      count: selectedRowKeys.length,
                    })
                  }}
                </p>
                <div class="flex justify-end mt-4">
                  <div
                    class="flex flex-row justify-end items-center gap-2 px-0 w-full"
                  >
                    <woot-button
                      @click="dispatchBroadcast"
                      class="button clear"
                      :disabled="uiFlags.isUpdating"
                    >
                      <template v-if="uiFlags.isUpdating">
                        <spinner />
                      </template>
                      <template v-else>
                        {{ $t('BROADCAST.MODAL.CONFIRM_BUTTON') }}</template
                      >
                    </woot-button>
                    <woot-button @click="closeSendModal" class="button clear">
                      {{ $t('BROADCAST.MODAL.CANCEL_BUTTON') }}
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </woot-modal>
          <woot-modal
            :show.sync="showSendAllModal"
            :on-close="closeSendAllModal"
          >
            <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
              <woot-modal-header
                :header-title="$t('BROADCAST.MODAL.HEADER_LABEL')"
              />
              <div class="mt-2 px-8">
                <p>
                  {{
                    $t('BROADCAST.MODAL.CONFIRM_APPROVE_ALL', {
                      count: pending_meta.pendingCount,
                    })
                  }}
                </p>
                <div class="flex justify-end mt-4">
                  <div
                    class="flex flex-row justify-end items-center gap-2 px-0 w-full"
                  >
                    <woot-button
                      @click="dispatchAllBroadcast"
                      class="button clear"
                      :disabled="uiFlags.isUpdating"
                    >
                      <template v-if="uiFlags.isUpdating">
                        <spinner />
                      </template>
                      <template v-else>
                        {{ $t('BROADCAST.MODAL.CONFIRM_BUTTON') }}</template
                      >
                    </woot-button>
                    <woot-button
                      @click="closeSendAllModal"
                      class="button clear"
                    >
                      {{ $t('BROADCAST.MODAL.CANCEL_BUTTON') }}
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </woot-modal>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import Datepicker from 'vue2-datepicker';
import Message from './Message.vue';
import BroadcastStats from './BroadcastStats.vue';
import BroadcastPending from './BroadcastPending.vue';
import BroadcastApproved from './BroadcastApproved.vue';
import BroadcastFooter from './Footer.vue';
import BroadcastApi from '../../../../api/broadcast';

export default {
  mixins: [alertMixin],
  components: {
    VeTable,
    Spinner,
    Datepicker,
    Message,
    BroadcastStats,
    BroadcastPending,
    BroadcastApproved,
    BroadcastFooter,
  },
  data() {
    return {
      templateName: this.$route.params.templateName,
      selectedRowKeys: [],
      selectedStatus: '',
      showSendModal: false,
      // showDenyModal: false,
      showSendAllModal: false,
      // showDenyAllModal: false,
      selectedTabIndex: 0,
      isExporting: false,
      statusOptions: [
        { key: 'sent', label: this.$t('BROADCAST.STATUS.SENT') },
        { key: 'delivered', label: this.$t('BROADCAST.STATUS.DELIVERED') },
        { key: 'read', label: this.$t('BROADCAST.STATUS.READ') },
        { key: 'failed', label: this.$t('BROADCAST.STATUS.FAILED') },
      ],
    };
  },
  computed: {
    ...mapGetters({
      broadcast_list: 'broadcastsView/getBroadcastsList',
      uiFlags: 'broadcastsView/getUiFlags',
      approvedData: 'broadcastsView/getApprovedData',
      meta: 'broadcastsView/getApprovedMeta',
      pending_meta: 'broadcastsView/getPendingMeta',
      template: 'broadcastsView/getTemplateData',
      inbox: 'broadcastsView/getInbox',
      pendingIds: 'broadcastsView/getPendingId',
      unread_count: 'broadcastsView/getUnreadCount'
    }),
    isAllSelected() {
      const ids = [...new Set(this.pendingIds)].filter(Boolean);
      return (
        ids.length > 0 && ids.every(id => this.selectedRowKeys.includes(id))
      );
    },
    firstIndex() {
      return (this.meta.currentPage - 1) * this.meta.perPage + 1;
    },
    lastIndex() {
      return Math.min(
        this.firstIndex + this.meta.perPage - 1,
        this.meta.allCount
      );
    },
    hasPrevPage() {
      return this.meta.currentPage > 1;
    },
    hasNextPage() {
      return this.meta.currentPage * this.meta.perPage < this.meta.allCount;
    },
    pendingFirstIndex() {
      return (
        (this.pending_meta.currentPage - 1) * this.pending_meta.perPage + 1
      );
    },
    pendingLastIndex() {
      return Math.min(
        this.pendingFirstIndex + this.pending_meta.perPage - 1,
        this.pending_meta.allCount
      );
    },
    pendingHasPrevPage() {
      return this.pending_meta.currentPage > 1;
    },
    pendingHasNextPage() {
      return (
        this.pending_meta.currentPage * this.pending_meta.perPage <
        this.pending_meta.allCount
      );
    },
    getInboxesName() {
      return this.inbox?.name || '';
    },
    approvedCount() {
      return this.meta.allCount;
    },
    tabs() {
      return [
        { id: 0, name: this.$t('BROADCAST.TABS.DETAIL') },
        {
          id: 1,
          name: this.$t('BROADCAST.TABS.PENDING'),
          count: this.pending_meta.pendingCount,
        },
        {
          id: 2,
          name: this.$t('BROADCAST.TABS.APPROVED'),
          count: this.approvedCount,
        },
        // {
        //   id: 3,
        //   name: 'Ditolak',
        //   count: 100,
        // },
      ];
    },
    // headerImage() {
    //   const data = this.template;

    //   // console.log('ini fallback2', this.broadcast_list?.[0]?.params?.message);
    //   // console.log('ini fallback', fallbackImageUrl);

    //   if (!data || !Array.isArray(data.components)) {
    //     return null;
    //   }

    //   const headerComponent = data.components.find(
    //     c => c.type === 'HEADER' && c.format === 'IMAGE'
    //   );

    //   const imageUrl = headerComponent?.example?.header_handle?.[0];

    //   // console.log('ini image url', imageUrl);

    //   if (imageUrl) {
    //     return imageUrl;
    //   }

    //   const fallbackImageUrl =
    //     this.broadcast_list?.[0]?.params?.message?.template_params?.header?.[1]
    //       ?.image?.link;

    //   return fallbackImageUrl || null;
    // },
    headerImage() {
      const data = this.template;

      let imageUrl = null;

      if (data && Array.isArray(data.components)) {
        const headerComponent = data.components.find(
          c => c.type === 'HEADER' && c.format === 'IMAGE'
        );
        imageUrl = headerComponent?.example?.header_handle?.[0];
      }

      if (imageUrl) {
        return imageUrl;
      }

      const fallbackImageUrl =
        this.broadcast_list?.[0]?.params?.message?.template_params?.header?.[1]
          ?.image?.link;

      return fallbackImageUrl || null;
    },
    buttonMessages() {
      const data = this.template;

      if (!data || !Array.isArray(data.components)) {
        return [];
      }

      const buttonComponent = data.components.find(c => c.type === 'BUTTONS');

      return Array.isArray(buttonComponent?.buttons)
        ? buttonComponent.buttons
        : [];
    },
    isButtonMessages() {
      return this.buttonMessages.length > 0;
    },
    contentHeader() {
      const components = this.template?.components || [];

      const headerComponent = components.find(
        component => component.type === 'HEADER' && component.format === 'TEXT'
      );

      return headerComponent?.text || null;
    },
    contentMessages() {
      const template = this.template;

      if (!template) return '';

      if (Array.isArray(template.components)) {
        const bodyComponent = template.components.find(c => c.type === 'BODY');
        return bodyComponent?.text || '';
      }

      if (typeof template.content === 'string') {
        return template.content;
      }
    },

    templateNames() {
      return this.template?.name || this.templateName;
    },
    templateLanguage() {
      const lang = this.template?.language;
      if (lang === 'id') {
        return 'id - ' + this.$t('BROADCAST.LANGUAGE.ID');
      } else if (lang === 'en_US') {
        return 'en_US - ' + this.$t('BROADCAST.LANGUAGE.EN');
      }
      return this.$t('BROADCAST.LANGUAGE.ID');
    },
    templateCategory() {
      return this.template?.category || 'UTILITY';
    },
  },

  methods: {
    async toggleSelectAll() {
      await this.$store.dispatch('broadcastsView/getPendingId', {
        template_name: this.templateName,
      });

      const ids = [...new Set(this.pendingIds)].filter(Boolean);

      if (this.selectedRowKeys.length) {
        this.selectedRowKeys = [];
      } else {
        this.selectedRowKeys = ids;
      }
    },
    onSelectedStatus() {
      this.fetchApprovedBroadcasts(this.templateName);
    },
    handleSelectedRows(keys) {
      this.selectedRowKeys = keys;
    },
    uncheckAll() {
      this.selectedRowKeys = [];
    },
    onRemoveStatus() {
      this.selectedStatus = null;
      this.fetchApprovedBroadcasts(this.templateName);
    },
    // openDenyAllModal() {
    //   this.showDenyAllModal = true;
    // },
    // closeDenyAllModal() {
    //   this.showDenyAllModal = false;
    // },
    // openDenyModal() {
    //   this.showDenyModal = true;
    // },
    // closeDenyModal() {
    //   this.showDenyModal = false;
    // },
    openDispatchModal() {
      this.showSendModal = true;
    },
    closeSendModal() {
      this.showSendModal = false;
    },
    openDispatchAllModal() {
      this.showSendAllModal = true;
    },
    closeSendAllModal() {
      this.showSendAllModal = false;
    },
    // async denyBroadcast() {
    //   try {
    //     const ids = this.selectedRowKeys;
    //     const data = {
    //       status_id: 3,
    //       rejected_at: new Date().toISOString(),
    //     };

    //     await this.$store.dispatch('broadcastsView/update', {
    //       id: ids,
    //       data,
    //     });

    //     this.showDenyModal = false;
    //     this.showAlert(this.$t('BROADCAST.ON_PROGRESS'));
    //     this.fetchBroadcasts(this.templateName);
    //   } catch (error) {
    //     console.error('Error updating broadcasts:', error);
    //   }
    // },
    async dispatchBroadcast() {
      const ids = this.selectedRowKeys;
      const data = {
        approved_at: new Date().toISOString(),
        status_id: 2,
      };

      await this.$store.dispatch('broadcastsView/update', {
        id: ids,
        data,
      });

      this.showSendModal = false;
      this.showAlert(this.$t('BROADCAST.ON_PROGRESS'));
      this.fetchBroadcasts(this.templateName);
      this.selectedRowKeys = [];
    },
    // async denyAllBroadcast() {
    //   try {
    //     await this.$store.dispatch('broadcastsView/getPendingId', {
    //       template_name: this.templateName,
    //     });

    //     if (this.pendingIds.length === 0) {
    //       this.showSendAllModal = false;
    //       this.showAlert(this.$t('BROADCAST.NO_PENDING'));
    //       return;
    //     }

    //     const data = {
    //       status_id: 3,
    //       rejected_at: new Date().toISOString(),
    //     };

    //     await this.$store.dispatch('broadcastsView/update', {
    //       id: this.pendingIds,
    //       data,
    //     });

    //     this.showDenyAllModal = false;
    //     this.showAlert(this.$t('BROADCAST.ON_PROGRESS'));
    //     this.fetchBroadcasts(this.templateName);
    //   } catch (error) {
    //     console.error('Error updating broadcasts:', error);
    //   }
    // },
    async dispatchAllBroadcast() {
      try {
        await this.$store.dispatch('broadcastsView/getPendingId', {
          template_name: this.templateName,
        });

        if (this.pendingIds.length === 0) {
          this.showSendAllModal = false;
          this.showAlert(this.$t('BROADCAST.NO_PENDING'));
          return;
        }

        const data = {
          approved_at: new Date().toISOString(),
          status_id: 2,
        };

        await this.$store.dispatch('broadcastsView/update', {
          id: this.pendingIds,
          data,
        });

        this.showSendAllModal = false;
        this.showAlert(this.$t('BROADCAST.ON_PROGRESS'));
        this.fetchBroadcasts(this.templateName);
      } catch (error) {
        console.error('Error updating broadcasts:', error);
      }
    },
    onTabChange(newIndex) {
      this.selectedTabIndex = newIndex;
      this.meta.currentPage = 1;
      this.pending_meta.currentPage = 1;
      this.selectedRowKeys = [];
      this.fetchBroadcasts(this.templateName);
      this.fetchApprovedBroadcasts(this.templateName);
    },
    async exportExcel() {
      this.isExporting = true;
      try {
        const { data } = await BroadcastApi.exportExcel(this.templateName, {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(data);
        link.download = `broadcast_${this.templateName}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        this.showAlert(this.$t('BROADCAST.EXPORT_ERROR'));
      } finally {
        this.isExporting = false;
      }
    },
    goBack() {
      this.$router.push(
        `/app/accounts/${this.$route.params.accountId}/broadcasts`
      );
    },
    onPerPageChange() {
      this.meta.currentPage = 1;

      this.fetchApprovedBroadcasts(this.templateName);
    },
    onFirstPage() {
      this.meta.currentPage = 1;
      this.fetchApprovedBroadcasts(this.templateName);
    },
    onPrevPage() {
      if (this.hasPrevPage) {
        this.meta.currentPage--;

        this.fetchApprovedBroadcasts(this.templateName);
      }
    },
    onNextPage() {
      if (this.hasNextPage) {
        this.meta.currentPage++;

        this.fetchApprovedBroadcasts(this.templateName);
      }
    },
    onLastPage() {
      this.meta.currentPage = Math.ceil(this.meta.allCount / this.meta.perPage);

      this.fetchApprovedBroadcasts(this.templateName);
    },
    onPendingPerPageChange() {
      this.pending_meta.currentPage = 1;
      this.fetchBroadcasts(this.templateName);
    },
    onPendingFirstPage() {
      this.pending_meta.currentPage = 1;
      this.fetchBroadcasts(this.templateName);
    },
    onPendingPrevPage() {
      if (this.pendingHasPrevPage) {
        this.pending_meta.currentPage--;
        this.fetchBroadcasts(this.templateName);
      }
    },
    onPendingNextPage() {
      if (this.pendingHasNextPage) {
        this.pending_meta.currentPage++;
        this.fetchBroadcasts(this.templateName);
      }
    },
    onPendingLastPage() {
      this.pending_meta.currentPage = Math.ceil(
        this.pending_meta.allCount / this.pending_meta.perPage
      );
      this.fetchBroadcasts(this.templateName);
    },
    async fetchBroadcasts(templateName) {
      await this.$store.dispatch('broadcastsView/show', {
        template_name: templateName,
        per_page: this.pending_meta.perPage,
        page: this.pending_meta.currentPage,
      });
    },

    async fetchApprovedBroadcasts(templateName) {
      await this.$store.dispatch('broadcastsView/getApproved', {
        template_name: templateName,
        per_page: this.meta.perPage,
        page: this.meta.currentPage,
        message_status: this.selectedStatus,
      });
    },
    async initPageData() {
      try {
        const template = this.templateName;
        await this.fetchBroadcasts(template);
        await this.$store.dispatch('broadcastsView/getApproved', {
          template_name: template,
          per_page: this.meta.perPage,
          page: 1,
        });
        await this.$store.dispatch('broadcastsView/getUnreadCount');
      } catch (error) {
        console.error('Error initializing data', error);
      }
    },
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
  },
  mounted() {
    this.initPageData();
  },
};
</script>

<style scoped>
.broadcast-view {
  display: flex;
  width: 100%;
  height: 100%;
}

#broadcast-tabs {
  height: 45px;
}

.custom-multiselect {
  max-width: 100%;
  white-space: normal;
}

.multiselect__tags {
  display: flex;
  flex-wrap: wrap;
}

.multiselect__tag {
  white-space: nowrap;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.wo.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.wo.list-group-item {
  border: 1px solid #697076;
  /* padding: 0.75rem 1.25rem; */
  position: center;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.broadcast-page {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0;
  margin: 0;
  width: 100%;
  height: calc(100vh - 176px);
}
</style>
